export const highlightedTextFragment = `
  fragment highlightedTextFragment on HighlightedTextRecord {
    color { fillColor }
    text
  }
`;
